import { nextTick, type Ref } from 'vue';
import { UserAssignGroups, type UserAssignGroup } from '../types';

export interface UseUserAssignRoleFilterOptions {
	userGroupListToDisplay: Ref<UserAssignGroup[]>;
	activeRoleFilterId: Ref<string | null>;
}

export function useUserAssignRoleFilter({
	userGroupListToDisplay,
	activeRoleFilterId,
}: UseUserAssignRoleFilterOptions) {
	/**
	 * Scrolls to the appropriate group based on current state:
	 * - If Project Members group is first, scrolls to top
	 * - Otherwise scrolls to the active role filter group
	 */
	const scrollToGroup = async (
		scrollContainer: Element | null,
		headerElement: Element | null
	) => {
		await nextTick();

		if (!scrollContainer) {
			return;
		}

		const isFirstGroupProjectMembers =
			userGroupListToDisplay.value[0]?.id ===
			UserAssignGroups.ProjectMembers;

		if (isFirstGroupProjectMembers) {
			scrollContainer.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		} else if (activeRoleFilterId.value) {
			const roleGroupElement = scrollContainer.querySelector<HTMLElement>(
				`[data-role-id="${activeRoleFilterId.value}"]`
			);
			const headerHeight = headerElement?.clientHeight ?? 0;

			if (roleGroupElement) {
				scrollContainer.scrollTo({
					top: roleGroupElement.offsetTop - headerHeight,
					behavior: 'smooth',
				});
			}
		}
	};

	return {
		scrollToGroup,
	};
}
